var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussiaAmGosloto7From49(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 70.699,
    cy: 51.675,
    r: 28.937,
    gradientTransform: "matrix(1 0 0 .1921 0 41.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.043
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#3d3f43",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 75.616,
    cy: 2.719,
    r: 24.873,
    gradientTransform: "matrix(1 0 0 2.0244 0 -2.786)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#f49ce5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#b04ce5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#b04ce5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#ac4ae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#a045d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#923fc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#753da6"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 67.752,
    cy: 31.415,
    r: 32.484,
    gradientTransform: "matrix(.7832 -.6217 .3483 .4387 3.746 59.757)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 77.428,
    cy: 5.509,
    r: 7.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 95.92,
    cy: 30.315,
    r: 7.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 72.316,
    cy: 14.701,
    r: 22.504,
    gradientTransform: "matrix(1 0 0 .6011 0 5.864)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#f49ce5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#ee95e5",
    stopOpacity: 0.807
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#df83e5",
    stopOpacity: 0.536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#c565e5",
    stopOpacity: 0.218
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#b04ce5",
    stopOpacity: 0
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 71.033,
    cy: 50.25,
    r: 11.891,
    gradientTransform: "matrix(1 0 0 .4975 0 25.252)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2f22"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 74.152,
    cy: 27.685,
    r: 25.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f49ce5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f49ce5"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 17.816,
    cy: 26.129,
    r: 40.022,
    gradientTransform: "matrix(.9164 .4003 -.3263 .7469 10.015 -.518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#f49ce5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#b04ce5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#b04ce5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#ac4ae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#a045d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#923fc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#753da6"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 35.279,
    cy: 23.571,
    r: 33.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 21.715,
    cy: 8.578,
    r: 8.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#04050e",
    stopOpacity: 0.908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#0e0c12",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#211a18",
    stopOpacity: 0.746
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#3a2c21",
    stopOpacity: 0.669
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 29.188,
    cy: 31.081,
    r: 27.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f49ce5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f49ce5"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 5.563,
    cy: 39.063,
    r: 7.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 35.67,
    cy: 54.862,
    r: 7.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2f22"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 52.139,
    cy: 25.155,
    r: 8.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 21.544,
    cy: 16.275,
    r: 23.831,
    gradientTransform: "matrix(.9521 -.3059 .2208 .6873 -2.561 11.678)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#f49ce5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#ee95e5",
    stopOpacity: 0.807
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#df83e5",
    stopOpacity: 0.536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#c565e5",
    stopOpacity: 0.218
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#b04ce5",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.64 71.745c0 1.96-11.17 3.55-24.94 3.55-13.78 0-24.95-1.59-24.95-3.55s11.17-3.55 24.95-3.55c13.78-.01 24.94 1.58 24.94 3.55z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.36 46.715c0 13.74-11.14 24.87-24.87 24.87-13.74 0-24.87-11.14-24.87-24.87 0-13.74 11.14-24.87 24.87-24.87s24.87 11.13 24.87 24.87z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.52 30.175c1.81-.61 4.99-1.49 8.34-1.11 5.12.58 9.52 1.64 12.08 2.99s4.34 2.42 5.1 5.71-.13 11.37-1.14 15.14c-1.02 3.77-1.69 6.64-4.43 8.15-2.74 1.5-7.41 2.44-13.71 1.23s-10.66-4.29-11.87-5.91-2.24-3.08-1.18-9.94c.79-5.14 1.22-9.39 3-12.69.6-1.09 1.78-2.88 3.81-3.57z",
    fill: "url(#c)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fffc4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75.03 34.505-5.52-.57-6.67 10.73-.22 4.37 5.85.76-.6 5.01 4.04.67.77-5.02 1.69.19.42-4.51-1.32-.25 1.56-11.38zm-5.82 10.91-2.34-.25v-.5l2.99-4.58-.65 5.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.27 57.455s7.37-5.38 7.7-12.8c.31-7.44-3.12-9.57-7.04-8.85-5.1.91-6.52 12.1.24 14.37-.49 2.81-2.56 4.5-4.28 5.9l3.38 1.38zm.74-14.19c.42 3.1 3.16 3.75 3.87 1.33.51-1.68-.02-4.64-1.83-4.84-1.73-.2-2.22 2.24-2.04 3.51z",
    fillRule: "evenodd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.03 25.345c4.47-.19 10.12.97 13.01 2.02 2.17.79 2.76-.1 3.1-1.43-3.92-2.58-8.61-4.1-13.66-4.1-1.99 0-3.92.26-5.77.7.22 1.44.99 2.91 3.32 2.81z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.48 24.435a24.775 24.775 0 0 0-11-2.59c-.64 0-1.27.05-1.9.1 1.98.89 5.26 2.15 8.72 2.52 1.84.19 3.17.13 4.18-.03z",
    fill: "#fffc4f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.76 41.425c-.51 2.48-.11 6.73-.98 10.25-.87 3.53-2.52 7.39.19 7.53 2.14-3.67 3.39-7.93 3.39-12.49 0-2.36-.35-4.64-.97-6.81-.76.16-1.43.57-1.63 1.52z",
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.64 44.665s3.11-1.69 7.21-2.19c4.1-.49 6.56 0 6.56 0s11.68-7.98 1.02-11.47c-10.3-3.37-18.94-2.68-21.35-.33-2.4 2.35-2.62 6.91-2.34 7.92s1.58-2.07 8.68 6.07",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.49 66.745c-3.19-.44-6.87-1.37-8.45-1.8-1.59-.44-2.68.06-3.33.82-.37.43-.39 1.67-.34 2.67 3.59 2.01 7.72 3.16 12.12 3.16a24.42 24.42 0 0 0 6.03-.77c.75-.89 1.28-1.77 1.2-2.44-.22-1.75-4.05-1.21-7.23-1.64z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m75.36 70.695.46-.67-6.12-2.48-1.78-.48-.49 1.64-2.61-.52-.29.88 2.5.57-.11.53 2.35.42.15-.36 5.94.47zm-5.7-1.26.13-.55h.61l2.13.8-2.87-.25z",
    fill: "#fffc4f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.48 21.845c-11.16 0-20.6 7.35-23.75 17.48 1.89-1.95 4.4-4.4 6.67-6.13 4.32-3.28 7.38-8.69 15.19-8.85s12.68.06 17.92 5.46c3.99 4.11 7.36 8.64 8.73 14.67-1.13-12.69-11.77-22.63-24.76-22.63z",
    fill: "url(#h)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.72 50.625c0 15.21-12.33 27.54-27.54 27.54S1.64 65.835 1.64 50.625s12.33-27.54 27.54-27.54 27.54 12.32 27.54 27.54z",
    fill: "url(#i)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.43 40.525c1.53-1.45 4.32-3.82 7.86-5 5.41-1.8 10.33-2.79 13.52-2.62 3.2.16 5.49.41 7.79 3.36s5.16 11.47 5.9 15.74c.74 4.26 1.39 7.46-.66 10.25s-6.31 5.9-13.2 7.62c-6.88 1.72-12.7.66-14.67-.41s-3.69-2.05-5.82-9.43c-1.6-5.53-3.15-10-2.89-14.14.09-1.38.44-3.73 2.17-5.37z",
    fill: "url(#j)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m33.48 63.895.15-26.12-15.99 5.79s2.04 6.1 2.51 5.79c.45-.29 7.42-2.97 7.42-2.97l-.38 20.2 6.29-2.69z",
    fillRule: "evenodd",
    fill: "#fffc4f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.29 29.955c2.52-.99 8.84-1.82 10.1-2.67.92-.63.78-2.35.2-4.08-.79-.07-1.59-.12-2.4-.12-6.79 0-12.99 2.47-17.8 6.54.05 1.11.26 2.25.89 2.71 1.38.98 6.48-1.39 9.01-2.38z",
    fill: "url(#k)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m25.64 26.605.38-3.33c-1.67.19-3.29.52-4.86 1l-.21 3.8 4.69-1.47z",
    fill: "#fffc4f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59 41.265c1.86-4.48 7.65-11.09 17.49-14.21 9.84-3.11 17.81 2.02 17.81 2.02s3.66-.16 6.94 1.75c1.86 1.08 5.07 5.22 7.5 8.61-4.29-9.63-13.93-16.35-25.15-16.35-15.21 0-27.54 12.33-27.54 27.54 0 2.13.26 4.2.72 6.19-.32-6.39.93-12.4 2.23-15.55z",
    fill: "url(#l)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 68.495c.54-.21 1.06-.61 1.21-1.42.35-1.88-2.87-6.63-3.71-11.18s-1.39-7.42-2.57-7.72c-.37-.09-.89-.01-1.41.14-.06.76-.12 1.53-.12 2.31-.01 6.82 2.49 13.05 6.6 17.87z",
    fill: "url(#m)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8 72.115c-4.4 2.42-13.26 2.23-13.41 4.26-.04.54.18 1.07.52 1.58 1.07.13 2.16.21 3.27.21 6.32 0 12.12-2.15 16.77-5.73-.07-.42-.17-.85-.32-1.25-.64-1.74-2.42-1.49-6.83.93z",
    fill: "url(#n)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.64 35.395c-.62 1.93 2.41 7.57 3.15 10.64s.64 9.25 3.15 8.91c1.06-.14 1.97-1.03 2.67-2 .06-.77.12-1.54.12-2.33 0-6.33-2.15-12.13-5.74-16.78-1.49.18-3.04.6-3.35 1.56z",
    fill: "url(#o)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23 66.225s-1.83-2.62-2.77-5.49-1.34-9.35-1.34-9.35l-1.42.35c.22 5.48 2.03 10.55 5 14.75.3-.14.53-.26.53-.26zm30.63 9.21c-3.86 1.29-9.63 2.03-9.63 2.03l.54.68.41.02a27.38 27.38 0 0 0 13.91-3.8l.07-1.15c0-.01-1.44.93-5.3 2.22zm17.37-24.05 1.48-.86c-.01-2.47-.37-4.86-.99-7.14l-.49 8zm-4.45-12.72 2.86-.66c-.61-1.18-1.3-2.3-2.07-3.37l-2.67 1.16 1.88 2.87z",
    fill: "#fffc4f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87 46.345s-.71-6.39 1.8-9.18 7.6-4.7 12.62-5.57c5.03-.87 10.33.27 11.26 2.02s.57 9.17-2.73 10.71c-3.74 1.75-10.33 5.19-15.08 5.85-4.75.65-7.16 1.09-7.87-3.83z",
    fill: "url(#p)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussiaAmGosloto7From49);
export default __webpack_public_path__ + "static/media/russia_am_gosloto_7_from_49.a04cf5705efb137b71a18c94e85e4013.svg";
export { ForwardRef as ReactComponent };